import { Controller } from "stimulus"

export default class extends Controller {
  disconnect() {
    this.notification?.remove()
  }

  async send(event) {
    event.preventDefault()
    // Handle the submission here before Rails UJS applies its own button disabling.
    event.stopPropagation()
    const form = event.currentTarget
    if (form.dataset.sending === "true") return

    const button = form.querySelector('[type="submit"]')
    const label = button.textContent
    const body = new FormData(form)
    form.dataset.sending = "true"
    button.disabled = true
    button.textContent = button.dataset.disableWith || "Sending…"

    try {
      const response = await fetch(form.action, {
        method: "POST",
        body,
        credentials: "same-origin",
        redirect: "error",
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || ""
        }
      })
      if (!response.headers.get("content-type")?.includes("application/json")) {
        throw new Error("Unable to send your request. Please check that you are signed in and try again.")
      }
      const result = await response.json()
      if (!response.ok) throw new Error(result.message || "Unable to send your request. Please try again.")
      this.showNotification(result.message, "success")
    } catch (error) {
      this.showNotification(error.message || "Unable to send your request. Please try again.", "error")
    } finally {
      delete form.dataset.sending
      button.disabled = false
      button.textContent = label
    }
  }

  showNotification(message, status) {
    if (!this.element.isConnected) return
    this.notification?.remove()
    const notification = document.createElement("div")
    notification.className = "alert event-email-notification d-flex justify-content-between align-items-center border border-dark m-1"
    notification.dataset.status = status
    notification.setAttribute("role", "alert")

    const text = document.createElement("span")
    text.textContent = message
    const close = document.createElement("button")
    close.type = "button"
    close.className = "close ms-2"
    close.setAttribute("aria-label", "Close notification")
    close.textContent = "×"
    close.addEventListener("click", () => notification.remove())
    notification.append(text, close)
    document.body.appendChild(notification)
    this.notification = notification
  }
}
